import { render, staticRenderFns } from "./ClassModal.vue?vue&type=template&id=46eb3eba&"
import script from "./ClassModal.vue?vue&type=script&lang=js&"
export * from "./ClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports